import checkIfStringEmpty from '_/common/utils/validation/checkIfStringEmpty';
import checkIfStringGuid from '_/common/utils/validation/checkIfStringGuid';
import * as Yup from 'yup';

const guidValidator = (fieldName: string): Yup.AnySchema =>
  Yup.string()
    .test('isRequired', (guid, { createError }) =>
      checkIfStringEmpty(guid) ? createError({ message: `${fieldName} is required.` }) : true,
    )
    .test('isValidGuid', (guid, { createError }) =>
      !checkIfStringGuid(guid) ? createError({ message: `${fieldName} must be a valid GUID.` }) : true,
    );

export default guidValidator;
